import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import { NewProfile } from "@/API/Models/Account/NewProfile";
import RegistrationProcessingModal from './RegistrationWizard/RegistrationProcessingModal.vue';
import { AuthenticationDAO } from "@/API/DAO/AuthenticationDAO";
import swal from 'sweetalert2';
let SelfRegisterViewModel = class SelfRegisterViewModel extends Vue {
    constructor() {
        super();
        this.profile = new NewProfile();
        this.acceptedTerms = false;
        this.verifyPassword = '';
    }
    mounted() {
        /* Here put things we want to run when we push the form to DOM */
        this.profile.emailAddress = '';
    }
    getError(fieldName) {
        return this.$validator.errors.first(fieldName);
    }
    get acceptedTermsStr() {
        if (this.acceptedTerms === true) {
            return 'true';
        }
        else {
            return null;
        }
    }
    get firstNameValidation() {
        return {
            required: true,
            min: 2
        };
    }
    get lastNameValidation() {
        return {
            required: true,
            min: 2
        };
    }
    get emailValidation() {
        return {
            email: true,
            required: true,
            min: 2
        };
    }
    get passwordValidation() {
        return {
            required: true,
            min: 2
        };
    }
    get acceptedTermsValidation() {
        return {
            required: true
        };
    }
    async emailChanged(event) {
        let userInfo = await AuthenticationDAO.getUserInformation(this.profile.emailAddress);
        if (userInfo.emailExists === true) {
            let warningResult = await swal.fire({
                title: `Email Already Registered`,
                text: `It appears you've already created an account for this email address.`,
                buttonsStyling: true,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonText: 'Reset my password',
                cancelButtonText: 'Try another email',
            });
            if (warningResult.value) {
                this.$router.push({
                    name: "IdentityRecoverPassword",
                    query: this.$route.query
                });
            }
            else {
                this.profile.emailAddress = '';
            }
        }
    }
    validate() {
        let accountInfo = { emailAddress: this.profile.emailAddress, password: this.profile.password, acceptedTerms: this.acceptedTerms };
        return this.$validator.validateAll().then(res => {
            this.$emit('on-validated', res, accountInfo);
            return res;
        });
    }
    redirectToHome() {
        this.$router.push({ name: 'IdentityLogin', query: this.$route.query });
    }
    async failedRegistrationRecovery() {
        this.$modal.hide('registrationProcessModal', this.profile);
        this.$router.push({ name: 'IdentityRecoveryPage', query: this.$route.query });
    }
    async failedRegistration() {
        this.$modal.hide('registrationProcessModal', this.profile);
    }
    async successfulRegistration() {
        this.$modal.hide('registrationProcessModal', this.profile);
        // @ts-ignore
        window.location = process.env.VUE_APP_CONFIGIO_URL + "/login?ReturnURL=%2FShoppingCart.aspx";
    }
    async register() {
        let valid = await this.validate();
        if (valid === true) {
            this.$modal.show('registrationProcessModal', this.profile);
        }
        return valid;
    }
    finishedRegistrationAttempt() {
        this.$modal.hide('registrationProcessingModal');
    }
};
SelfRegisterViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
            'registration-processing-modal': RegistrationProcessingModal
        }
    })
], SelfRegisterViewModel);
export default SelfRegisterViewModel;
